import { Link } from "react-router-dom";
import * as React from "react";
import { developAxios } from "../axios.config";
import { Alert } from "react-bootstrap";

const CreateSubProject = () => {
	const [course, setCourse] = React.useState("");
	const [courses, setCourses] = React.useState([]);

	const [project, setProject] = React.useState("");
	const [projects, setProjects] = React.useState([]);

	const [projectName, setProjectName] = React.useState("");
	const [projectDescription, setProjectDescription] = React.useState("");

	const [projectIcon, setProjectIcon] = React.useState("");
	const [projectIconFile, setProjectIconFile] = React.useState(null);

	const [executableFiles, setExecutableFiles] = React.useState(null);

	const [screenshots, setScreenshots] = React.useState([]);
	const [screenshotsUri, setScreenshotsUri] = React.useState([]);

	const [outOfScore, setOutOfScore] = React.useState(0);
	const [projectLevel, setProjectLevel] = React.useState("Easy");

	// const onImageChange = event => {
	//   if (event.target.files && event.target.files[0]) {
	//     let reader = new FileReader();
	//     let file = event.target.files[0];
	//     setImageFile(file);
	//     reader.onloadend = () => {
	//       setImageUri(reader.result);
	//     };
	//     reader.readAsDataURL(file);
	//   }
	// };

	// select course
	React.useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/getallcourse", {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setCourses(data.courses);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, []);

	// select course
	React.useEffect(() => {
		if (course === "") return;
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/dashboard/get-projects-by-courseId/" + course, {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setProjects(data.projects);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, [course]);

	const handleSubmit = (e) => {
		e.preventDefault();
		const formData = new FormData();
		formData.append("projectImage", projectIconFile);
		formData.append("parentProjectId", project);
		formData.append("projectName", projectName);
		formData.append("projectDescription", projectDescription);
		formData.append("outOfScore", Number(outOfScore));
		formData.append("projectLevel", projectLevel);
		formData.append("executableFiles", executableFiles);
		screenshots.forEach((screenshot) => {
			formData.append("screenshots", screenshot);
		});
		developAxios(localStorage.getItem("token"))
			.post("/dashboard/create-sub-project", formData)
			.then(({ data }) => {
				console.log(data);
				alert("Sub Project Created Successfully");
				window.location.reload();
			})
			.catch((err) => console.log(err?.response));
	};

	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "flex-start",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					alignSelf: "center",
					width: "500px",
					paddingBottom: "50px",
					paddingTop: "50px",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<h5>Course:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setCourse(e.target.value);
						}}
					>
						<option value="">Select Course</option>
						{courses.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.name}
								</option>
							);
						})}
					</select>
				</div>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<h5>Projects:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							// set id of course
							setProject(e.target.value);
						}}
					>
						<option value="">Select Project</option>
						{projects.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.projectName}
								</option>
							);
						})}
					</select>
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Sub Project Name:</h5>{" "}
					<input
						type="text"
						name="project_name"
						id="project_name"
						onChange={(e) => {
							setProjectName(e.target.value);
						}}
					/>
				</div>

				{/* Select project level from easy, medium, hard */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Level:</h5>{" "}
					<select
						// className="w-50"
						aria-label="Default select example"
						name="project_level"
						id="project_level"
						onChange={(e) => {
							// set id of course
							setProjectLevel(e.target.value);
						}}
					>
						<option value="">Select Project Level</option>
						<option value="Easy">Easy</option>
						<option value="Medium">Medium</option>
						<option value="Hard">Hard</option>
					</select>
				</div>

				{/* Project Out of Score */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Out of Score:</h5>{" "}
					<input
						type="text"
						name="project_out_of_score"
						id="project_out_of_score"
						onChange={(e) => {
							setOutOfScore(e.target.value);
						}}
					/>
				</div>

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Description:</h5>{" "}
					<input
						type="file"
						name="project_description"
						id="project_description"
						onChange={(e) => {
							setProjectDescription(e.target.files[0]);
						}}
					/>
				</div>

				{/* Project Image upload */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Sub Project Icon:</h5>{" "}
					<input
						type="file"
						accept="image/*"
						name="project_image"
						id="project_image"
						onChange={(e) => {
							if (e.target.files && e.target.files[0]) {
								let reader = new FileReader();
								let file = e.target.files[0];
								setProjectIconFile(file);
								reader.onloadend = () => {
									setProjectIcon(reader.result);
								};
								reader.readAsDataURL(file);
							}
						}}
					/>
				</div>

				{/* Show selected image */}
				{projectIcon && (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							marginTop: "20px",
						}}
					>
						<h5>Selected Project Icon:</h5>{" "}
						<img
							src={projectIcon}
							alt="Avatar"
							className="avatar"
							style={{
								height: "200px",
								objectFit: "contain",
							}}
						/>
					</div>
				)}

				{/* Project Screenshots upload */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Screenshots:</h5>{" "}
					<input
						type="file"
						accept="image/*"
						name="project_screenshots"
						id="project_screenshots"
						multiple
						onChange={(e) => {
							if (e.target.files && e.target.files.length > 0) {
								let files = e.target.files;
								files = Array.from(files);
								setScreenshots(files);
							}
						}}
					/>
				</div>

				{/* Project Executable Files upload */}
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<h5>Project Executable Files:</h5>{" "}
					<input
						type="file"
						name="project_executable_files"
						id="project_executable_files"
						onChange={(e) => {
							setExecutableFiles(e.target.files[0]);
						}}
					/>
				</div>

				{/* Create Project button */}

				<div
					style={{
						display: "flex",
						flexDirection: "column",
						marginTop: "20px",
					}}
				>
					<button
						className="btn btn-primary"
						style={{
							height: "50px",
						}}
						onClick={handleSubmit}
					>
						Create Project
					</button>
				</div>
			</div>
		</div>
	);
};

export default CreateSubProject;
